import { API_BASE } from './client';

/** The API host without its /api suffix — where /uploads is served from. */
const ORIGIN = API_BASE.replace(/\/api\/?$/, '');

/**
 * Resolves a stored image reference for display.
 *
 * Catalogue artwork is stored as a path ("/uploads/catalog/x.png") rather than
 * an absolute URL, because the server only knows its hostname from BASE_URL.
 * Absolute URLs are left alone so externally hosted or S3 images still work.
 */
export const mediaUrl = value => {
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  return `${ORIGIN}${value.startsWith('/') ? '' : '/'}${value}`;
};

/** The swatches shipped with the platform, offered as one-click choices. */
export const CATALOG_SWATCHES = [
  { label: 'HDPE (blue)', path: '/uploads/catalog/hdpe-tarpaulin.png' },
  { label: 'PVC (charcoal)', path: '/uploads/catalog/pvc-tarpaulin.png' },
  { label: 'Canvas (natural)', path: '/uploads/catalog/canvas-tarpaulin.png' },
  { label: 'Truck covers (red)', path: '/uploads/catalog/truck-covers.png' },
  { label: 'Agri (green)', path: '/uploads/catalog/agri-covers.png' },
  { label: 'Pond liner (teal)', path: '/uploads/catalog/pond-liners.png' },
];

export default mediaUrl;
